import { call, put, select, takeLatest } from "redux-saga/effects";

import { SelectAllActionTypes } from "./types/actionTypes";
import { setSnackbar } from "../generals/actionCreators";
import { getRequestError } from "@src/utils/getRequestError";
import { selectAllApi } from "@src/service/api";
import { fetchOldProduct } from "./types/actionCreators";

export function* fetchProductLocationsRequest(): any {
  try {
    yield put({
      type: SelectAllActionTypes.SET_SELECT_ALL_LOADER,
      payload: true,
    });

    const currRestaurantGroupId = localStorage.getItem("currRestGroupId") ?? "";

    const { data } = yield call(
      selectAllApi.getLocations,
      currRestaurantGroupId
    );

    yield put({
      type: SelectAllActionTypes.FETCH_SELECT_ALL_LOCATIONS_SUCCESS,
      payload: data,
    });

    yield put({
      type: SelectAllActionTypes.SET_SELECT_ALL_LOADER,
      payload: false,
    });
  } catch (e) {
    yield put({ type: SelectAllActionTypes.FETCH_SELECT_ALL_LOCATIONS_ERROR });
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* fetchNewProductRequest(action: any): any {
  try {
    const { product_id, menu_id, product } = action.payload;
    const restaurant_id = localStorage.getItem("currLocation") || "";
    const { page } = yield select((state) => state.selectAll);

    const payload = {
      product,
      attribute_groups: [],
      default_attributes: [],
      menu_id,
      restaurant_id,
    };
    // yield put({ type: SelectAllActionTypes.SET_NEW_PRODUCT, payload: product });
    yield put(fetchOldProduct(menu_id, product_id, payload, page));
  } catch (e) {
    yield put({
      type: SelectAllActionTypes.SET_SELECT_ALL_LOADER,
      payload: false,
    });
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* fetchOldNewProductDifferenceRequest(action: any) {
  try {
    yield put({
      type: SelectAllActionTypes.SET_SELECT_ALL_LOADER,
      payload: true,
    });
    const { product_id, product, page } = action.payload;
    const { data } = yield call(
      selectAllApi.getOldProductVersion,
      product_id,
      product
    );

    yield put({
      type: SelectAllActionTypes.FETCH_SELECT_ALL_OLD_PRODUCT_SUCCESS,
      payload: { data, page },
    });

    yield put({
      type: SelectAllActionTypes.SET_SELECT_ALL_LOADER,
      payload: false,
    });
  } catch (e) {
    yield put({
      type: SelectAllActionTypes.SET_SELECT_ALL_LOADER,
      payload: false,
    });
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* setSelectedLocationsRequest(action: any) {
  try {
    const { product_id, selectedLocations } = action.payload;

    const { newProduct, newAttributeGroup, newDefaultAttribute } = yield select(
      (state) => state.selectAll
    );

    const selectedRestaurant = selectedLocations[0];

    const payload = {
      product: newProduct,
      attribute_groups: newAttributeGroup,
      default_attributes: newDefaultAttribute,
      menu_id: selectedRestaurant.menu_id,
      restaurant_id: selectedRestaurant.restaurant_id,
    };

    yield put(fetchOldProduct("", product_id, payload, 1));
    yield put({
      type: SelectAllActionTypes.SET_SELECT_ALL_SELECTED_LOCATIONS,
      payload: selectedLocations,
    });
  } catch (e) {
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* submitProductChangesRequest(action: any) {
  try {
    const { product_id, menu_id, body } = action.payload;
    yield call(selectAllApi.updateSAProduct, product_id, body);

    const { newProduct, selectedLocations, page } = yield select(
      (state) => state.selectAll
    );
    yield put(
      setSnackbar({
        status: "success",
        message: "Success updated",
        visible: true,
      })
    );

    if (selectedLocations.length >= page + 1) {
      const reqBody = {
        product: newProduct,
        attribute_groups: body.attribute_groups,
        default_attributes: body.default_attributes,
        menu_id: selectedLocations[page].menu_id,
        restaurant_id: selectedLocations[page].restaurant_id,
      };

      yield put({
        type: SelectAllActionTypes.SUBMIT_SELECT_ALL_PRODUCT_CHANGES_SUCCESS,
      });
      yield put(fetchOldProduct(menu_id, product_id, reqBody, page + 1));
    }
  } catch (e) {
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* selectAllSaga(): any {
  yield takeLatest(
    SelectAllActionTypes.FETCH_SELECT_ALL_LOCATIONS_SAGA,
    fetchProductLocationsRequest
  );
  yield takeLatest(
    SelectAllActionTypes.SET_SELECT_ALL_SELECTED_LOCATIONS_SAGA,
    setSelectedLocationsRequest
  );
  yield takeLatest(
    SelectAllActionTypes.FETCH_SELECT_ALL_OLD_PRODUCT_SAGA,
    fetchOldNewProductDifferenceRequest
  );
  yield takeLatest(
    SelectAllActionTypes.SUBMIT_SELECT_ALL_PRODUCT_CHANGES_SAGA,
    submitProductChangesRequest
  );
}
